var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAjassaLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 279.93 279.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 139.97,
    cy: 139.97,
    r: 139.97,
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m139.97,231.68c-1.15,0-2.3-.34-3.31-1.01-5.48-3.65-24.81-17.01-43.48-35.73-25.1-25.19-38.1-49.05-38.62-70.94,0-.01,0-.02,0-.03v-.06c0-.43-.02-.85-.02-1.28,0-27.37,21.37-49.64,47.64-49.64,14.95,0,28.88,7.35,37.78,19.39,8.9-12.04,22.83-19.39,37.78-19.39,26.27,0,47.64,22.27,47.64,49.64,0,.45,0,.89-.02,1.34,0,0,0,.02,0,.03-.53,21.88-13.52,45.75-38.62,70.94-18.66,18.72-37.99,32.08-43.48,35.73-1.01.67-2.16,1.01-3.31,1.01Zm-73.11-107.98c.44,18.13,12.49,39.57,34.86,62.01,15.1,15.16,31.05,26.87,38.25,31.9,7.21-5.03,23.15-16.74,38.25-31.9,22.36-22.44,34.42-43.88,34.86-62.02,0-.35.01-.7.01-1.06,0-20.3-15.86-36.82-35.34-36.82-13.82,0-26.45,8.47-32.18,21.57-1,2.28-3.19,3.75-5.6,3.75h0c-2.41,0-4.6-1.47-5.6-3.75-5.73-13.1-18.36-21.57-32.18-21.57-19.49,0-35.34,16.52-35.34,36.82,0,.34,0,.68.01,1.02v.04Zm152.37.15h0,0Z",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjassaLike);
export default __webpack_public_path__ + "static/media/ajassa_like.61f86a3e3b75f0e22284929211f730a8.svg";
export { ForwardRef as ReactComponent };